import React, { useState } from "react";
import { MdClose, MdChevronLeft, MdChevronRight } from "react-icons/md";

const ImagePopup = ({ visible, onHide, images = [], title = "Images" }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  const validImages = images.filter(
    (url) => url && url.trim() !== "" && url !== "null"
  );

  if (!visible || validImages.length === 0) return null;

  const handleNext = () => {
    setLoading(true);
    setCurrentIndex((prev) => (prev + 1) % validImages.length);
  };

  const handlePrev = () => {
    setLoading(true);
    setCurrentIndex((prev) => (prev - 1 + validImages.length) % validImages.length);
  };

  const handleClose = () => {
    setCurrentIndex(0);
    onHide();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">
      <div className="relative bg-white rounded-lg max-w-4xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button
            onClick={handleClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            <MdClose />
          </button>
        </div>

        {/* Image Container */}
        <div className="relative flex items-center justify-center min-h-[400px] min-w-[600px]">
          {/* Loader */}
          {loading && (
            <div className="absolute flex items-center justify-center w-full h-full bg-gray-100">
              <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
            </div>
          )}

          <img
            src={validImages[currentIndex]}
            alt={`Bill ${currentIndex + 1}`}
            className={`max-w-full max-h-[70vh] object-contain mx-auto block transition-opacity duration-300 ${
              loading ? "opacity-0" : "opacity-100"
            }`}
            onLoad={() => setLoading(false)}
            onError={(e) => {
              setLoading(false);
              e.target.src =
                "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2Y3ZjdmNyIvPgogIDx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkb21pbmFudC1iYXNlbGluZT0iY2VudHJhbCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Im1vbm9zcGFjZSIgZm9udC1zaXplPSIxNHB4IiBmaWxsPSIjOTk5Ij5JbWFnZSBub3QgZm91bmQ8L3RleHQ+Cjwvc3ZnPg==";
            }}
          />

          {/* Navigation Arrows */}
          {validImages.length > 1 && (
            <>
              <button
                onClick={handlePrev}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-75 transition-all"
              >
                <MdChevronLeft className="text-xl" />
              </button>
              <button
                onClick={handleNext}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-75 transition-all"
              >
                <MdChevronRight className="text-xl" />
              </button>
            </>
          )}
        </div>

        {/* Footer */}
        {validImages.length > 1 && (
          <div className="p-4 border-t text-center text-gray-600">
            {currentIndex + 1} of {validImages.length}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImagePopup;
